module.exports = __webpack_public_path__ + "img/40_38_027_430.dc6814af.jpg";